import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import { getDataWithEndpoint } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
  validData,
} from "../../../functions/functionsUtility";
import { toast } from "react-toastify";
import { DescriptionsLayout } from "../../../layout";
import { FaSave } from "react-icons/fa";

const estados = [
  { value: "AC", label: "Acre" },
  { value: "BA", label: "Bahia" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso(Sul)" },
  { value: "MN", label: "Mato Grosso(Norte)" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "TR", label: "Minas Gerais(Triangulo)" },
  { value: "PA", label: "Pará" },
  { value: "PR", label: "Paraná" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RO", label: "Rondônia" },
  { value: "RS", label: "Rio Grande do Sul (P. Alegre)" },
  { value: "RF", label: "Rio Grande do Sul (Fronteira)" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "TO", label: "Tocantins" },
  { value: "ES", label: "Espírito Santo" },
  { value: "RR", label: "Roraima" },
];

const cotacoesLabel = [
  { value: "cot_boi", label: "Boi Gordo" },
  { value: "cot_vaca", label: "Vaca" },
  { value: "cot_bezerro", label: "Bezerro 240 KG" },
  { value: "cot_magro", label: "Boi Magro 375 KG" },
  { value: "cot_boi_av", label: "Boi Gordo (à Vista)" },
  { value: "cot_vaca_av", label: "Vaca (à Vista)" },
];

export default function InterboisTop() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value], index) => {
    if (key !== "cot_data" && key !== "cot_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "boi_cottop",
              `getBoiCottopbyuf?uf=${encodeURIComponent(value)}`,
              "updateBoiCottop"
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.cot_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interbois - Cotações Top"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                const canSave = await validData(cotacoesData, ["cot_boi"]);
                if (!canSave) {
                  toast.error(
                    "Preencha todos os campos obrigatórios! Campo: Boi Gordo"
                  );
                  return;
                }
                updateData({
                  ...cotacoesData,
                  endpoint: "updateBoiCottop",
                  path: "boi_cottop",
                });
              }}
            >
              Atualizar
            </Button>
          </div>
        }
      />
    </>
  );
}
